<div fxFlex fxLayout="column" class="content">

  <!-- not able to connect as player -->
  <ng-container *ngIf="applicationMode == ApplicationMode.playerMode">
    <div  class="title">
      {{'playerNotAvailable.title' | translate}}
  </div>


    <div class="info">
      {{'playerNotAvailable.info1' | translate}}
    </div>

    <div fxLayout="column" class="devices">
      <div *ngIf="(zoneConnectionPlayerApplicationInfo$ | async) != null">
        {{(zoneConnectionPlayerApplicationInfo$ | async).deviceInfo}}
      </div>
    </div>

    <div *ngIf="(enableConnect$ | async)" class="info infoLast">
      {{'playerNotAvailable.info2' | translate}}
    </div>
    <div *ngIf="!(enableConnect$ | async)" class="info infoLast">
      {{'playerNotAvailable.noConnect.info2' | translate}}
    </div>
  </ng-container>

  <!-- not able to connect as remote -->
  <ng-container *ngIf="applicationMode == ApplicationMode.remoteMode">
    <div  class="title">
      {{'connectNotAvailable.title' | translate}}
  </div>


    <div class="info">
      {{'connectNotAvailable.info1' | translate}}
    </div>

    <div fxLayout="column" class="devices">
      <div *ngIf="(zoneConnectionPlayerApplicationInfo$ | async) != null">
        {{(zoneConnectionPlayerApplicationInfo$ | async).deviceInfo}}
      </div>
    </div>

    <div class="info infoLast">
      {{'connectNotAvailable.info2' | translate}}
    </div>
  </ng-container>



  <div class="button-container" fxLayout="row">
    <button type="submit" fxFlex fxLayout="row"
      (click)="onClose()" class="button button-ok"
    >
        OK
    </button>
  </div>

</div>
